import { cosemApi } from '@services/providers/cosem';
import { ApiPaginationResponse, ApiResponse } from '@services/providers/cosem.types';
import { Order, OrderTable } from './order.types';
import { ActiveFilter } from '@utils/filters';

const orderApi = cosemApi.injectEndpoints({
    endpoints: (build) => ({
        getOrders: build.mutation<ApiPaginationResponse<OrderTable>, { limit?: number; page?: number; search?: string; orderBy?: string, filters?: ActiveFilter[] }>({
            query: ({ limit = 10, page = 1, search, orderBy, filters }) => {
                return { 
                    url: `/product/orders`, 
                    method: 'GET',
                    params: { limit, page, search: search ?? "", orderBy: orderBy ?? "", filters: JSON.stringify(filters ?? []) }
                };
            },
            transformResponse: (response: ApiPaginationResponse<OrderTable>) => response
        }),
        getMemberOrders: build.mutation<ApiPaginationResponse<OrderTable>, { id: string|number, limit?: number; page?: number; search?: string; orderBy?: string, filters?: ActiveFilter[] }>({
            query: ({ id, limit = 10, page = 1, search, orderBy, filters }) => {
                return { 
                    url: `/product/orders/member/${id}`, 
                    method: 'GET',
                    params: { limit, page, search: search ?? "", orderBy: orderBy ?? "", filters: JSON.stringify(filters ?? []) }
                };
            },
            transformResponse: (response: ApiPaginationResponse<OrderTable>) => response
        }),
        getOrder: build.mutation<ApiResponse<Order>, { id: string|number }>({
            query: ({ id }) => {
                return { 
                    url: `/product/orders/${id}`, 
                    method: 'GET',
                };
            },
            transformResponse: (response: ApiResponse<Order>) => response
        }),
        getOrdersExport: build.mutation<ApiResponse<string>, { search?: string; orderBy?: string; filters?: ActiveFilter[] }>({
            query: ({ search, orderBy, filters }) => {
                return {
                    url: `/product/orders/export`,
                    method: 'GET',
                    params: { search: search ?? '', orderBy: orderBy ?? '', filters: JSON.stringify(filters ?? []) }
                };
            },
            transformResponse: (response: ApiResponse<string>) => response
        }),
    })
});

export const { 
    useGetOrdersMutation,
    useGetMemberOrdersMutation,
    useGetOrderMutation,
    useGetOrdersExportMutation,
} = orderApi;
